import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";

const ProjectCreateModal = ({ isOpen, toggle, onSubmit }) => {
    const [projectName, setProjectName] = useState('');
    const [projectId, setProjectId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Reset form when modal opens
    useEffect(() => {
        if (isOpen) {
            setProjectName('');
            setProjectId('');
        }
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!projectName.trim() || !projectId.trim()) {
            return;
        }

        setIsSubmitting(true);

        try {
            await onSubmit({
                name: projectName,
                ac_id: projectId,
            });
            
            // Close the modal
            toggle();
        } catch (error) {
            console.error("Error adding project:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered
            scrollable
        >
            <ModalHeader toggle={toggle} className="activegroup-header">
                Add New Project
            </ModalHeader>
            <ModalBody className="px-5 py-4">
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="projectName">Project Name</Label>
                                <Input
                                    type="text"
                                    id="projectName"
                                    value={projectName}
                                    onChange={(e) => setProjectName(e.target.value)}
                                    placeholder="Enter project name"
                                    required
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="projectId">Project ID</Label>
                                <Input
                                    type="text"
                                    id="projectId"
                                    value={projectId}
                                    onChange={(e) => setProjectId(e.target.value)}
                                    placeholder="Enter project ID"
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSubmit} disabled={isSubmitting || !projectName.trim() || !projectId.trim()}>
                    {isSubmitting ? 'Saving...' : 'Save'}
                </Button>
                <Button color="secondary" onClick={toggle}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ProjectCreateModal;